import React from "react";

import { Col, Row, Breadcrumb, BreadcrumbItem } from "reactstrap";

const Header = () => {
  return (
    <Row className="mb-2 mb-xl-4">
      <Col xs="auto">
        <Breadcrumb>
          <BreadcrumbItem>Admin / Campaign On-Off</BreadcrumbItem>
        </Breadcrumb>
      </Col>
    </Row>
  );
};

export default Header;
